import React, { useEffect, useState } from 'react';
import { AddStoreItemType } from 'models/store-item.model';
import { Fragment } from 'react';
import useInventoryStoreContext from 'contexts/inventory-store.context/context';

const UpdateStorePreviewItems = ({
  item,
  setItem,
  vendorIngredientIdsToDelete
}: {
  item: AddStoreItemType;
  setItem: (arg1: AddStoreItemType) => void;
  vendorIngredientIdsToDelete: string[];
  setVendorIngredientIdsToDelete: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  // const [items, setItems] = useState<AddStoreItemType[]>([DefaultStoreItem]);
  const { storeItemsToEdit } = useInventoryStoreContext();

  // Initialize showStoreDetails based on the selected item's index
  const [showStoreDetails, setShowStoreDetails] = useState(
    Array.from({ length: storeItemsToEdit.length }, (_, index) => index === 0)
  );

  const toggleStoreDetails = (index: number) => {
    setShowStoreDetails((prevDetails) => {
      const updatedShowStoreDetails = [...prevDetails];
      updatedShowStoreDetails[index] = !updatedShowStoreDetails[index];
      return updatedShowStoreDetails;
    });
  };

  useEffect(() => {
    // setItems([item]);
    setItem(item);
  }, [item, setItem]);

  return (
    <Fragment>
      <div className='ml-2 md:ml-8 request'>
        <div className='bg-white w-full maxw-[670px] h-auto rounded-md pt-2'>
          <h4 className='font-semibold text-[20px] -ml-8 mt-[-30px]'>Update Selected Items</h4>
          <p className='mt-2 -ml-8 text-xs text-gray-9 '>Change item details</p>
          <div>
            {storeItemsToEdit &&
              storeItemsToEdit.map((item, index) => {
                const shelfLifeValue = item.shelfLife ?? item.shelf_life;
                const unitType = item.unit_type || 'g';
                const hasMinQty = item.min_quantity || item.min_quantity === 0;
                const minQtyValue = hasMinQty
                  ? `${item.min_quantity}${item.unit_type ? ` ${item.unit_type}` : ''}`
                  : '-';

                return (
                  <div key={index} className='mt-4 w-full edit_form'>
                    <div className='bg-[#F7F7F7E5] border-b border-[#EAEBEB] py-3 ml-[-60px] mr-[-28px] flex justify-between'>
                      <p className='text-[16px]  font-medium pl-[28px]'>{item?.name}</p>
                      <div
                        className='bg-white border border-[#EAEBEB] rounded-[100px] px-4 py-2 text-xs font-medium text-[#5E6164] cursor-pointer mr-[28px]'
                        onClick={() => toggleStoreDetails(index)}>
                        {showStoreDetails[index] ? 'Hide' : 'Show'}
                      </div>
                    </div>
                    {showStoreDetails[index] && (
                      <div className='-ml-8'>
                        <div key={index} className='p-2 flex justify-between mr-4 mt-2'>
                          <p className='text-sm font-medium '>Item Name</p>
                          <p className='text-[#6F7376] text-xs'>{item?.name || '-'}</p>
                        </div>
                        <hr className='text-[#f0eded]' />
                        <div key={index} className='p-2 flex justify-between mr-4 mt-2'>
                          <p className='text-sm font-medium '>Min. qty</p>
                          <p className='text-[#6F7376] text-xs'>{minQtyValue}</p>
                        </div>
                        <hr className='text-[#f0eded]' />
                        <div key={index} className='p-2 flex justify-between mr-4 mt-2'>
                          <p className='text-sm font-medium '>Unit type</p>
                          <p className='text-[#6F7376] text-xs'>{item.unit_type || '-'}</p>
                        </div>
                        <hr className='text-[#f0eded]' />
                        <div key={index} className='p-2 flex justify-between mr-4 mt-2'>
                          <p className='text-sm font-medium '>{`Unit per (${unitType})`}</p>
                          <p className='text-[#6F7376] text-xs'>{item.unit_weight || '-'}</p>
                        </div>
                        <hr className='text-[#f0eded]' />
                        <div key={index} className='p-2 flex justify-between mr-4 mt-2'>
                          <p className='text-sm font-medium '>Category</p>
                          <p className='text-[#6F7376] text-xs'>{item.category || '-'}</p>
                        </div>
                        <hr className='text-[#f0eded]' />
                        <div key={index} className='p-2 flex justify-between mr-4 mt-2'>
                          <p className='text-sm font-medium '>Shelf Life</p>
                          <p className='text-[#6F7376] text-xs'>{shelfLifeValue ?? '-'}</p>
                        </div>
                        <hr className='text-[#f0eded]' />
                        {item?.vendor_ingredients.filter(
                          (vendor_ingredient) =>
                            !vendorIngredientIdsToDelete.includes(vendor_ingredient.id)
                        )?.length > 0 &&
                          item.vendor_ingredients
                            .filter(
                              (vendor_ingredient) =>
                                !vendorIngredientIdsToDelete.includes(vendor_ingredient.id)
                            )
                            .map((vendor_ingredient, vendor_index) => {
                              const vendorKey = vendor_ingredient.id || `${index}-${vendor_index}`;
                              return (
                                <Fragment key={vendorKey}>
                                  <div className='p-2 flex justify-between mr-4 mt-2'>
                                    <p className='text-sm font-medium '>
                                      {vendor_ingredient.vendor.name}
                                    </p>
                                    <p className='text-[#6F7376] text-xs'>
                                      ₦ {vendor_ingredient.gram_price}
                                    </p>
                                  </div>
                                  <hr className='text-[#f0eded]' />
                                </Fragment>
                              );
                            })}
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UpdateStorePreviewItems;
